import AbstractFilter from '../AbstractFilter';
import { FILTER_EVENT } from '../FilterEvent';

export default class EnhancedIntegerFilter extends AbstractFilter {
  constructor(...args) {
    super(...args);
    this._values = [parseInt(this._dom.container.value)];
    this._autoSubmit = this._dom.container.hasAttribute('data-auto-submit') ?? false;
    this._bind();
    this._displayValue = this._dom.container.getAttribute('data-display-value');
  }

  _bind() {
    this._dom.container.addEventListener('change', () => {
      this._values = [parseInt(this._dom.container.value) || 10];
      this.emit(FILTER_EVENT.CHANGED, { interactive: true });
      if (this._autoSubmit === true) {
        this.emit(FILTER_EVENT.AUTO_SUBMIT);
      }
      if (this._displayValue !== null) {
        this.emit(FILTER_EVENT.DISPLAY_VALUE);
      }
      this.emit(FILTER_EVENT.CLOSED);
    });
  }

  setValues(values) {
    this._dom.container.value = values[0];
  }

  isMultiple() {
    return false;
  }

  removeAllChoices() {
    this._values = [];
    this._dom.container.value = '';
    this.emit(FILTER_EVENT.CHANGED, { interactive: false });
  }
}
